import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import '../../../assets/css/customer/about/WhoWeAre.css';

const WhoWeAre = () => {
  const features = [
    "Quam felis ultricies nec pellentesque eu pretium",
    "Fringilla volutpat nec vulputate eget arcu in eni",
    "Yusto rhoncusul imperdiet a venenatis vitae"
  ];

  return (
    <section className="who-we-are-section">
      <Container>
        <Row className="align-items-center">
          {/* Left Side - Content */}
          <Col lg={6} md={12} className="content-col-left">
            <div className="content-wrapper-left">
              {/* Small Label */}
              <p className="section-label">Who We Are</p>

              {/* Main Heading */}
              <h2 className="section-heading-left">
                Planner for Your<br />
                Perfect Wedding
              </h2>

              {/* Description */}
              <p className="section-description-left">
                We are a smart wedding event management platform designed to help users plan and organize their special day with ease. From selecting venues to  invitations, our system brings everything together in one place for a smooth and stress-free experience.
              </p>

              {/* Feature List */}
              <ul className="feature-list">
                {features.map((feature, index) => (
                  <li key={index} className="feature-item">
                    <div className="check-icon">
                      <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                        <circle cx="10" cy="10" r="9" stroke="#7fd3c1" strokeWidth="1.5" fill="none"/>
                        <path d="M6 10 L9 13 L14 7" stroke="#7fd3c1" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                      </svg>
                    </div>
                    <span className="feature-text">{feature}</span>
                  </li>
                ))}
              </ul>

              {/* CTA Button */}
              <button className="btn-get-quote">
                Get a Free Quote
              </button>
            </div>
          </Col>

          {/* Right Side - Image */}
          <Col lg={6} md={12} className="image-col-right">
            <div className="image-container-right">
              {/* Main Image */}
              <div className="couple-image-frame">
                <img 
                  src="https://i.pinimg.com/736x/54/9e/ac/549eaca078e34303f632605cbd63253e.jpg" 
                  alt="Wedding Couple"
                  className="couple-image"
                />
              </div>

              {/* Decorative Leaves at Bottom */}
              <div className="bottom-leaves">
                <svg width="180" height="100" viewBox="0 0 180 100" fill="none">
                  {/* Left leaves */}
                  <ellipse cx="30" cy="60" rx="20" ry="28" fill="#c8e0d4" opacity="0.6" transform="rotate(-25 30 60)"/>
                  <ellipse cx="50" cy="65" rx="18" ry="26" fill="#b8d4c8" opacity="0.5" transform="rotate(-15 50 65)"/>
                  <ellipse cx="70" cy="70" rx="22" ry="30" fill="#c8e0d4" opacity="0.6" transform="rotate(-10 70 70)"/>
                  
                  {/* Right leaves */}
                  <ellipse cx="110" cy="70" rx="22" ry="30" fill="#b8d4c8" opacity="0.5" transform="rotate(10 110 70)"/>
                  <ellipse cx="130" cy="65" rx="18" ry="26" fill="#c8e0d4" opacity="0.6" transform="rotate(15 130 65)"/>
                  <ellipse cx="150" cy="60" rx="20" ry="28" fill="#b8d4c8" opacity="0.5" transform="rotate(25 150 60)"/>
                </svg>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default WhoWeAre;